export function AccountantBarChart({ labels, values, ariaLabel, tone = "primary" }) {
  const width = 760;
  const height = 300;
  const padding = { top: 22, right: 18, bottom: 52, left: 62 };
  const chartWidth = width - padding.left - padding.right;
  const chartHeight = height - padding.top - padding.bottom;
  const safeValues = values.length ? values : [0];
  const rawMax = Math.max(...safeValues, 1);
  const maxValue = Math.ceil(rawMax / 1000) * 1000 || 1;
  const gridLines = 5;
  const slotWidth = chartWidth / Math.max(labels.length, 1);
  const barWidth = Math.min(54, slotWidth * 0.66);

  return (
    <div className="accountant-chart-canvas">
      <svg viewBox={`0 0 ${width} ${height}`} role="img" aria-label={ariaLabel}>
        {Array.from({ length: gridLines + 1 }).map((_, index) => {
          const y = padding.top + (chartHeight / gridLines) * index;
          const value = maxValue - (maxValue / gridLines) * index;
          return (
            <g key={`grid-${index}`}>
              <line className="accountant-chart-grid-line" x1={padding.left} x2={width - padding.right} y1={y} y2={y} />
              <text className="accountant-chart-axis-text" x={padding.left - 10} y={y + 4} textAnchor="end">
                {Math.round(value).toLocaleString()}
              </text>
            </g>
          );
        })}

        {labels.map((label, index) => {
          const value = values[index] || 0;
          const barHeight = (value / maxValue) * chartHeight;
          const x = padding.left + slotWidth * index + (slotWidth - barWidth) / 2;
          const y = padding.top + chartHeight - barHeight;
          return (
            <g key={`${label}-${index}`}>
              <rect className={`accountant-chart-bar is-${tone}`} x={x} y={y} width={barWidth} height={barHeight} rx="2">
                <title>{`${label}: ${value.toLocaleString()}`}</title>
              </rect>
              <text className="accountant-chart-axis-text" x={x + barWidth / 2} y={height - 24} textAnchor="middle">
                {label}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}

export function AccountantDonutChart({ title, unit, items }) {
  const total = items.reduce((sum, item) => sum + item.value, 0);
  const radius = 94;
  const circumference = 2 * Math.PI * radius;
  let offset = 0;

  return (
    <div className="accountant-donut-wrap">
      <div className="accountant-donut" role="img" aria-label={title}>
        <svg className="accountant-donut-svg" viewBox="0 0 240 240" aria-hidden="true">
          <circle className="accountant-donut-track" cx="120" cy="120" r={radius} />
          {items.map((item) => {
            const segmentLength = total ? (item.value / total) * circumference : 0;
            const currentOffset = offset;
            offset += segmentLength;
            return (
              <circle
                key={item.key}
                className={`accountant-donut-segment is-${item.key}`}
                cx="120"
                cy="120"
                r={radius}
                strokeDasharray={`${segmentLength} ${circumference - segmentLength}`}
                strokeDashoffset={-currentOffset}
              >
                <title>
                  {item.label}: {item.value}
                </title>
              </circle>
            );
          })}
        </svg>
        <div className="accountant-donut-center">
          <strong>{total}</strong>
          <span>{unit}</span>
        </div>
      </div>
      <div className="accountant-chart-legend">
        {items.map((item) => (
          <span key={item.key}>
            <i className={`is-${item.key}`} />
            {item.label}
            <strong>{item.value}</strong>
          </span>
        ))}
      </div>
    </div>
  );
}
